import { AiPresenceOverviewResponse } from "../../../components/ai-presence-screen/types";
import { BrandOverviewResponse } from "../../../components/my-brand-screen/types";
import { CampaignOverviewResponse } from "../../../components/my-campaigns-screen/types";
import { MyCompetitionOverviewResponse, SpendEfficiencyOverviewResponse } from "../../../components/my-competition-screen/types";
import { SocialOverviewResponse } from "../../../components/social-overview-screen-a/types";
import { ATTENTION_METRIC_NAME } from "../../types/common";

export enum CardType {
    SINGLE = 'single',
    MULTIPLE = 'multiple'
}

export enum MetricType {
    ATTENTION = 'attention',
    DWELL_TIME = 'dwellTime',
    IMPRESSIONS = 'impressions',
    DAILY_IMPRESSIONS = 'dailyImpressions',
    CLICK_RISK = 'clickRisk',
    CLUTTER = 'clutter',
    VIEWABILITY = 'viewability',
    CTR = 'ctr',
    CPM = 'cpm',
    BRAND_VISIBILITY = 'brandVisibility',
    AI_SENTIMENT = 'sentiment',
    MY_SHARE_OF_VOICE = 'myShareOfVoice',
    AI_VISIBILITY_RETURN = 'visibilityReturn',
    EFFICIENCY = 'efficiency',
    IMPACT = 'impact',
    SPEND = 'spend'
}

export enum MetricTitle {
    ATTENTION = `${ATTENTION_METRIC_NAME}`,
    DWELL_TIME = 'Avg. Dwell Time',
    CLUTTER = 'Avg. Ad Clutter',
    CLICK_RISK = 'Unintended Click Risk',
    DAILY_IMPRESSIONS = 'Daily Imps.',
    IMPRESSIONS = 'Impressions',
    VIEWABILITY = 'Viewability',
    AVG_CPM = 'Avg. CPM',
    CPM = 'CPM',
    CTR = 'CTR',
    BRAND_VISIBILITY = 'Brand Visibility',
    AI_SENTIMENT = 'AI Sentiment',
    MY_SHARE_OF_VOICE = 'My Share of Voice',
    AI_VISIBILITY_RETURN = 'AI Visibility Return',
    SPEND = 'Spend'
}

export enum MetricIcon {
    ATTENTION = 'svg/glasses.svg',
    DWELL_TIME = 'svg/eye.svg',
    CLUTTER = 'svg/squares.svg',
    CLICK_RISK = 'svg/click.svg',
    CTR = 'svg/click.svg',
}

export enum ValueType {
    POSITIVE = 'positive',
    NEGATIVE = 'negative',
    NEUTRAL = 'neutral',
    MID_POSITION = 'mid-position',
    NA = 'N/A'
}

export interface Trend {
    value: number;
    arrowDirection: 'up' | 'down';
    status: ValueType;
}

export interface Tooltip {
    brand: string;
    color: string;
    impressions?: string;
    value?: string;
}

export interface Metric {
    title: string;
    value: string | undefined;
    valueType?: ValueType;
    valueDescription?: string;
    trend?: Trend;
    tooltip?: Tooltip[];
    titleTooltip?: string;
    titleTooltipPlace?: 'above' | 'below';
}

export interface SingleMetricConfig extends Metric {
    type: CardType.SINGLE;
    iconPath?: string;
}

export interface MultipleMetricsConfig {
    type: CardType.MULTIPLE;
    metrics: Metric[];
}

export type OverviewCardConfig = MultipleMetricsConfig | SingleMetricConfig;
export type OverviewResponse = CampaignOverviewResponse | BrandOverviewResponse | MyCompetitionOverviewResponse | AiPresenceOverviewResponse | SpendEfficiencyOverviewResponse | SocialOverviewResponse;
